import { Hidden } from "@material-ui/core";
import React from "react";
import DeskFooter from "./desktopFooter";
import MobFooter from "./mobileFooter";

export default function Header() {
  return (
    <>
      <Hidden smDown>
        <DeskFooter />
      </Hidden>
      <Hidden mdUp>
        <MobFooter />
      </Hidden>
    </>
  );
}
